import { render } from "./PedigreeCardView.vue?vue&type=template&id=0807127a&scoped=true&ts=true"
import script from "./PedigreeCardView.vue?vue&type=script&lang=ts"
export * from "./PedigreeCardView.vue?vue&type=script&lang=ts"

import "./PedigreeCardView.vue?vue&type=style&index=0&id=0807127a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0807127a"]])

export default __exports__